export const ESI_ADMIN_ADHERENCE = 'esi-admin-adherence';
export const ESI_ADMIN_ADHERENCE_RESULT = `${ESI_ADMIN_ADHERENCE}/result`;
export const ESI_ADMIN_ADHERENCE_CLEAR = `${ESI_ADMIN_ADHERENCE}/clear`;
export const ESI_ADMIN_ADHERENCE_ERROR = `${ESI_ADMIN_ADHERENCE}/error`;

export const ESI_ADMIN_CAP_EVOLUTION = 'esi-admin-cap-evolution';
export const ESI_ADMIN_CAP_EVOLUTION_RESULT = `${ESI_ADMIN_CAP_EVOLUTION}/result`;
export const ESI_ADMIN_CAP_EVOLUTION_CLEAR = `${ESI_ADMIN_CAP_EVOLUTION}/clear`;
export const ESI_ADMIN_CAP_EVOLUTION_ERROR = `${ESI_ADMIN_CAP_EVOLUTION}/error`;
